import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'formManagementExperience.list'

const FormManagementFormListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default FormManagementFormListSlice
